import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Hub } from '@aws-amplify/core'
import LanguageIcon from '@material-ui/icons/Language'
import { Button, Typography, Menu, MenuItem } from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import { useTranslation } from 'react-i18next'
import { logOutUser } from '../../../redux/slices/auth'
import { delay } from '@src/utils/miscellaneous'

function LogOutButton() {
  const { t, i18n } = useTranslation()
  const disptach = useDispatch()
  const [cantLogOut, setcantLogOut] = useState(false)

  const handleLogout = () => {
    disptach(logOutUser())
  }

  useEffect(() => {
    if (window.navigator.onLine) {
      setcantLogOut(false)
    } else {
      setcantLogOut(true)
    }
    // Waits for datastores initial sync process to complete
    const removeListener = Hub.listen('datastore', async capsule => {
      const {
        payload: { event, data },
      } = capsule
      if (event === 'networkStatus' && !data.active) {
        setcantLogOut(true)
      } else if (event === 'networkStatus' && data.active) {
        setcantLogOut(false)
      }
      if (event === 'modelSynced' || event === 'subscriptionsEstablished') {
        setcantLogOut(true)
      }

      if (event === 'ready' || event === 'syncQueriesReady') {
        // Use datastore to fetch quotes
        await delay(1500)
        setcantLogOut(false)
      }
      if (event === 'outboxStatus' && !data.isEmpty) {
        // Use datastore to fetch quotes
        setcantLogOut(true)
      } else if (event === 'outboxStatus' && data.isEmpty) {
        // Use datastore to fetch quotes
        setcantLogOut(false)
      }
    })
    // dispatch(logOutUser())

    return () => {
      removeListener()
    }
  }, [])

  return (
    <div style={{ marginRight: '5px' }}>
      <Button
        aria-label='logout'
        aria-controls='menu-appbar'
        aria-haspopup='true'
        color='inherit'
        onClick={handleLogout}
        disabled={cantLogOut}
      >
        <Typography variant='subtitle2'>{t('offlineQuotes:logOut')}</Typography>
        <ExitToAppIcon fontSize='small' />
      </Button>
    </div>
  )
}

export default LogOutButton
